import { create } from 'zustand'

// 커맨드 팔레트 열림 상태를 전역으로 공유한다(헤더 트리거 ↔ 팔레트 컴포넌트).
// 별도 Provider 없이 zustand 스토어로 깔끔하게 연결한다.
interface CommandPaletteState {
    open: boolean
    setOpen: (open: boolean) => void
    toggle: () => void
}

export const useCommandPalette = create<CommandPaletteState>((set) => ({
    open: false,
    setOpen: (open) => set({ open }),
    toggle: () => set((s) => ({ open: !s.open })),
}))
